import {
  ApplicableRecommendation,
  ApplicableRecommendationData,
} from '../types/contentValidation';

// Function to segregate recommendations by qualityCheckCategory
export const segregateRecommendations = (
  recommendations: ApplicableRecommendationData[]
): Record<string, ApplicableRecommendationData[]> => {
  return recommendations.reduce(
    (acc, recommendation) => {
      const category = recommendation.qualityCheckCategory;
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(recommendation);
      return acc;
    },
    {} as Record<string, ApplicableRecommendationData[]>
  );
};

// Function to segregate recommendations by qualityCheckCategory without isSelected
export const segregateRecommendationsWithoutisSelected = (
  recommendations: ApplicableRecommendation[]
): Record<string, ApplicableRecommendation[]> => {
  return recommendations.reduce(
    (acc, recommendation) => {
      const category = recommendation.qualityCheckCategory;
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(recommendation);
      return acc;
    },
    {} as Record<string, ApplicableRecommendation[]>
  );
};
